import React from "react";
import { Modal as EtModal } from "@ever-tutor/et-ui";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
  closeOnEscape?: boolean;
  className?: string;
  contentClassName?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  showCloseButton = true,
  closeOnEscape = true,
  className = "",
  contentClassName = "",
}) => {
  return (
    <EtModal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={showCloseButton}
      closeOnEscape={closeOnEscape}
      className={className}
      contentClassName={contentClassName}
      aria-label="Modal"
    >
      {children}
    </EtModal>
  );
};

export default Modal;
